import { ClosePromptModel, ClosePromptServiceImplementation } from "../sdServices/closePromptService";

export let addClosePromptEvent = ($state: ng.ui.IStateService) => {
  // listen to beforeunload event
  window.addEventListener("beforeunload", (event: any) => {
    // check if this state or any of its parent states have a closePromptMessage registered.
    let closePromptStateMap = ClosePromptServiceImplementation.closePromptStateMap;
    let foundState = checkIfSelfOrParentStateIsRegistered($state, closePromptStateMap);
    let confirmMessage = undefined;
    if (foundState) {
      let closePromptCallback = closePromptStateMap.get(foundState);
      let closePromptModel: ClosePromptModel = closePromptCallback();
      if (closePromptModel) {
        confirmMessage = closePromptModel.shouldDisplayClosePrompt ? closePromptModel.message : undefined;
      }
    }

    if (event && confirmMessage) {
      event.returnValue = confirmMessage;
    }

    return confirmMessage;
  });
};

let checkIfSelfOrParentStateIsRegistered = ($state: ng.ui.IStateService, closePromptStateMap: Map<string, any>) => {
  let currentStateObj: any = $state.$current;
  let currentStateName = currentStateObj.name;

  // check if current state is registered for callback
  if (closePromptStateMap.has(currentStateName)) {
    return currentStateName;
  }

  // check if any ancestor state is registered for callback
  let parent = currentStateObj.parent;
  while (parent) {
    if (closePromptStateMap.has(parent.name)) {
      return parent.name;
    }

    parent = parent.parent;
  }

  return undefined;
};
